import { animate, keyframes, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CURRENT_LANGUAGE } from '../../constants';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  animations: [    
    trigger('speedDialStagger', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('40ms', [
          animate('200ms ease',
          keyframes([
            style({ opacity: 0, transform: 'translateY(-40px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ])
        )]
        ), { optional: true }),
        query(':leave',
          animate('200ms ease',
            keyframes([
              style({ opacity: 1 }),
              style({ opacity: 0 }),
            ])
          ), { optional: true }
        )
      ])
    ])
  ]
})
export class LanguageComponent implements OnInit {

  constructor(private translateService: TranslateService, private translationService: TranslationService) { }

  languageList: string[];
  currentLanguage;

  languages = [];
  isOpen = false;

  ngOnInit() {
    this.languageList = this.translationService.translationList;
    this.currentLanguage = this.translateService.currentLang;
  }

  showItems() {
    this.isOpen = true;
    this.languages = this.languageList;
  }

  hideItems() {
    this.isOpen = false;
    this.languages = [];
  }

  toggle() {
    this.languages.length
      ? this.hideItems()
      : this.showItems();
  }

  onChangeLanguage(language: string) {
    if(language == this.currentLanguage){
      return;
    }
    this.translateService.use(language);
    sessionStorage.setItem(CURRENT_LANGUAGE, language);
    this.currentLanguage = language;
    this.hideItems();
  }

  getIconClass(language: string){
    return `flag flag-${language}-circle`;
  }
}
